import { useEffect, useRef } from "react"

import { useNavigationGuardStore } from "@/stores/useNavigationGuardStore"

interface UseNavigationGuardParams {
  shouldBlock: boolean
  onNavigationConfirmHandler?: () => void
}

interface UseNavigationGuardReturn {
  disableBlock: () => void
}

export const useNavigationGuard = ({
  shouldBlock,
  onNavigationConfirmHandler,
}: UseNavigationGuardParams): UseNavigationGuardReturn => {
  const setShouldBlock = useNavigationGuardStore((s) => s.setShouldBlock)
  const setOnNavigationConfirmHandler = useNavigationGuardStore((s) => s.setOnNavigationConfirmHandler)
  const callbackRef = useRef(onNavigationConfirmHandler)
  callbackRef.current = onNavigationConfirmHandler

  useEffect(() => {
    setShouldBlock(shouldBlock)
    return () => setShouldBlock(false)
  }, [shouldBlock, setShouldBlock])

  useEffect(() => {
    if (!callbackRef.current) return
    const stableCallback = () => callbackRef.current?.()
    setOnNavigationConfirmHandler(stableCallback)
    return () => setOnNavigationConfirmHandler(null)
  }, [setOnNavigationConfirmHandler])

  return { disableBlock: () => setShouldBlock(false) }
}
